export default class Tag {
  name: string
  ownerId: any

  constructor(json) {
    this.name = json.name
    this.ownerId = json.owner_id
  }
}
